import { createSlice } from "@reduxjs/toolkit";

import { fetchTutorialXpaths } from "./";

const initialState = {
	xpaths: [],
	page: "",
};

export const tutorialSlice = createSlice({
	name: "tutorial",
	initialState,
	reducers: {
		setXpaths: (state, { payload }) => {
			state.xpaths = payload;
		},
		setPage: (state, { payload }) => {
			state.page = payload;
		},
	},
	extraReducers: (builder) => {
		builder.addCase(fetchTutorialXpaths.fulfilled, (state, { payload }) => {
			state.xpaths = payload;
		});
	},
});

export const { actions: tutorialActions, reducer: tutorialReducer } = tutorialSlice;
